module.exports = __webpack_public_path__ + "img/iconAskForHelp.7c353561.svg";